// extracted by mini-css-extract-plugin
export default {"root":"AiOrganizeTooltip__root--fSYgz","tipContent":"AiOrganizeTooltip__tipContent--2QbQn","tipText":"AiOrganizeTooltip__tipText--1a7n_"};